import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Import Advanced Shipping Notice from CSV',
    id: '5z/M8n',
    description: 'Asn Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: 'l6Pkbh',
    defaultMessage: 'Import Advanced Shipping Notice',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    id: 'RMY8h6',
    defaultMessage: 'Advanced Shipping Notice Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  name: {
    defaultMessage: 'Name',
    id: '0OBrUm',
    description: 'ASN product import column name',
  },
  sku: {
    defaultMessage: 'SKU',
    id: '+LlCJY',
    description: 'ASN product import column sku',
  },
  quantity: {
    defaultMessage: 'Quantity',
    id: 'pfAE3p',
    description: 'ASN product import column quantity',
  },
  asn_pallet: {
    defaultMessage: 'Pallet',
    id: 'WmgarK',
    description: 'ASN product import column pallet',
  },
  asn_carton: {
    defaultMessage: 'Carton',
    id: '1KEGDc',
    description: 'ASN product import column carton',
  },
});
